import { Box, Divider, Grid, TextField, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import Switch from '/@/components/switch';
import colors from '/@/components/theme-provider/colors';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { getUser } from '/@/store/session/selectors';
import type { Field } from '/@/types/field';

export const MobileHeader = ({
    handleViewList,
    handleViewMap,
    fieldName,
    handleQueryChange,
    handleQueryReset,
    userTypeView = 'user',
    fields,
    activeView,
}: {
    user: { first_name: string };
    handleViewList: () => void;
    handleViewMap: () => void;
    fieldName: string;
    handleQueryChange: (value: string) => void;
    handleQueryReset: () => void;
    userTypeView?: 'user' | 'rv';
    fields: Field[];
    activeView: string;
}) => {
    const user = useSelector(getUser);
    return (
        <Box>
            {userTypeView === 'user' && (
                <Box sx={{ p: 1 }}>
                    <Typography color='primary' variant='h6'>
                        {_('Hola, ') + user.first_name}
                    </Typography>
                    <Typography color='primary' variant='caption'>
                        {_('Gestioná tus lotes con recomendaciones para potenciar el rendimiento de tus cultivos')}
                    </Typography>
                </Box>
            )}
            <Divider />

            <Box sx={{ p: 1 }}>
                <Grid container justifyContent={'space-between'}>
                    <Grid item xs={4}>
                        <Typography color='primary' variant='caption' fontWeight={500}>
                            {_('Mis lotes')}
                        </Typography>
                    </Grid>
                    <Grid item container xs={8} justifyContent={'flex-end'} spacing={1}>
                        <Grid item container spacing={1} sx={{ width: 'auto' }} alignItems={'center'}>
                            <Grid item>
                                <Typography color='primary' variant='caption'>
                                    {_('Lista de lotes')}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Switch
                                    sx={{
                                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                            backgroundColor: colors.themes[settings.app.theme].secondary.default,
                                        },
                                    }}
                                    checked={activeView === 'map'}
                                    onChange={() => {
                                        activeView === 'map' ? handleViewList() : handleViewMap();
                                    }}
                                />
                            </Grid>
                            <Grid item>
                                <Typography color='primary' variant='caption'>
                                    {_('Mapa')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {userTypeView === 'user' && (
                    <TextField
                        sx={{ mt: 1 }}
                        fullWidth
                        label={_('Buscar')}
                        size='small'
                        variant='outlined'
                        value={fieldName}
                        onChange={(e) => {
                            handleQueryChange(e.target.value);
                        }}
                        onReset={handleQueryReset}
                        disabled={fields?.length === 0 && !fieldName}
                    />
                )}
            </Box>
        </Box>
    );
};

export default MobileHeader;
